const baseURL = process.env.REACT_APP_BACKEND_URL;

export default baseURL;

export const endPoints = {
    //auth
    login: "/User/Login",
forgot:"/User/SendOtp",
verifyOtp:"/User/Verify-otp",
resetPassword:"/User/reset-password",
    //refresh token
    refreshToken: "/User/refresh-token",

    //Dropdowns
    getStatusDropdown: "/Dropdown/getAllStatus",
    getBannerTypesDropdown: "/Dropdown/getAllBannersType",
    getRoleDropdown: "/Dropdown/getAllRoles",
    getTransmissionDropdown: "/Transmission/getAll",
    getCountryDropdown: "/Dropdown/getAllCountries",
    getYearsDropdown: "/Years/getAll",
    getPowerTypeDropdown: "/Dropdown/getAllPowertypes",
    getPartsDropdown: "/Parts/getPartsDropDown",
    getVariantsDropdown: "/Dropdown/getAllVariants",
    getCurrenciesDropdown: "/Dropdown/getCurrenciesDropDown",
    getMakersDropdown: "/Dropdown/getAllMakers",
    getCategoriesDropdown: "/Dropdown/getAllCategories",
    getTransmissionsDropdown: "/Dropdown/getAllTransmissions",
    getAllFeatures: "/Dropdown/getAllFeatures",
    getModelsDropdown: (filterString) => `/Dropdown/getAllModels?${filterString}`,
    getallDimensions: "/Dropdown/getAllDimensions",
    getallBrands: "/Dropdown/getAllBrands",
    getallShipments: "/Dropdown/getAllShipments",
    getallConditions: "/Dropdown/getAllConditions",

    //getCategoryWiseParts
    getCategoriesWiseParts: "/Vehicle/getPartWithCategories",

    //Dashboard
    getReportsData: "/Dashboard/reports",
    getDashboardData: "/Dashboard/dashboard",
    getHotSellingData: "/Dashboard/HotSellingModel",

    //Users
    getallUsers: (id) => `/User/getAllUser/${id}`,
    createUser: "/User/create",
    updateUser: (id) => `/User/update/${id}`,
    getUserById: (id) => `/User/getById/${id}`,
    deleteUser: (id) => `/User/delete/${id}`,
    sendOtp: "/User/sendOtp",
    // verifyOtp: "/User/verify-otp",
    resetPassword: "/User/reset-password",

    //Maker
    getallMakers: "/Maker/getAll",
    addMaker: "/Maker/create",
    updateMaker: "/Maker/update",
    getMakerById: (id) => `/Maker/get/${id}`,
    deleteMaker: (id) => `/Maker/delete/${id}`,
    makerStatus: "/Maker/status",

    //Model
    getallModels: "/Model/getAll",
    addModel: "/Model/create",
    updateModel: (id) => `/Model/update/${id}`,
    getModelById: (id) => `/Model/get/${id}`,
    deleteModel: (id) => `/Model/delete/${id}`,
    modelStatus: "/Model/status",

    //Category
    getallCategory: "/Category/getAll",
    addCategory: "/Category/create",
    updateCategory: "/Category/update",
    getCategoryById: (id) => `/Category/get/${id}`,
    deleteCategory: (id) => `/Category/delete/${id}`,
    categoryStatus: "/Category/status",

    //Feature
    getallFeature: "/api/Feature/getAll",
    addFeature: "/api/Feature/create",
    updateFeature: (id) => `/api/Feature/update/${id}`,
    getFeatureById: (id) => `/api/Feature/get/${id}`,
    deleteFeature: (id) => `/api/Feature/delete/${id}`,
    featureStatus: "/api/Feature/status",

    //Banners
    getallBanner: "/Banner/getAll",
    addBanner: "/Banner/create",
    updateBanner: "/Banner/update",
    getBannerById: (id) => `/Banner/get/${id}`,
    deleteBanner: (id) => `/Banner/delete/${id}`,

    //Dimensions
    getallDimension: "/Dimensions/GetAll",
    addDimension: "/Dimensions/create",
    updateDimension: "/Dimensions/update",
    getDimensionById: (id) => `/Dimensions/get/${id}`,
    deleteDimension: (id) => `/Dimensions/delete/${id}`,
    dimensionStatus: "/Dimensions/status",

    //Inventories
    getAllInventory: (params) => `/Inventory/GetAll?${params}`,
    addPart: "/Parts/create",
    getInventoryById: (id) => `/Inventory/get/${id}`,
    getInventoryLogsById: (id) => `/Inventory/inventoryLogs/${id}`,

    //Parts
    getallParts: (params) => `/Parts/getAll?${params}`,
    addPart: "/Parts/create",
    updatePart: "/Parts/update",
    updatePartStatus: "/Parts/update",
    getPartById: (id) => `/Parts/get/${id}`,
    deletePart: (partsdataId) => `/Parts/delete/${partsdataId}`,
    partStatus: "/Parts/status",

    //Variants
    getallVariants: (params) => `/Variant/getAll?${params}`,
    addVariant: "/Variant/create",
    updateVariant: (id) => `/Variant/update/${id}`,
    getVariantById: (id) => `/Variant/get/${id}`,
    deleteVariant: (variantId) => `/Variant/delete/${variantId}`,
    variantStatus: "/Variant/status",

    //MasterParts
    getallMasterParts: "/api/MasterParts/getAll",
    addMasterPart: "/api/MasterParts/create",
    updateMasterPart: "/api/MasterParts/update",
    getMasterPartById: (id) => `/api/MasterParts/get/${id}`,
    deleteMasterPart: (id) => `/api/MasterParts/delete/${id}`,
    masterPartsStatus: "/api/MasterParts/status",

    //Quotation
    getallQuotations: (params) => `/Quotation/getAll?${params}`,
    getQuotationById: (id) => `/Quotation/get/${id}`,
    quotationReply: "/Quotation/admin/reply",
};
